module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1050-4d28236915ed670665879d067d5a7b61.png";